import { FC } from 'react';

import { useModal } from 'shared/lib/modal';
import { Confirm } from 'shared/ui/confirm';
import { ButtonContained } from 'shared/ui/buttons/buttonContained';

type Props = {
    onClose: () => void;
}

export const LogoutConfirm: FC<Props> = ({ onClose }) => {
    const { closeModal } = useModal();

    const handleLogout = () => {
        closeModal();
        onClose();

        localStorage.clear();

        window.location.pathname = '/login';
    }

    return (
        <>
            <Confirm
                title={'Вы уверены что хотите выйти из аккаунта и завершить работу?'}
                confirmButton={
                    <ButtonContained
                        onClick={handleLogout}
                    >
                        Да, выйти
                    </ButtonContained>
                }
                cancelButtonLabel="Нет, продолжить работу"
                onClose={onClose}
            />
        </>
    );
};
